(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * AffiliateWP Multi-Tier Commissions
 *
 * @since 1.0.0
 */

'use strict';

/* eslint-disable no-console, no-undef */
affiliatewp.attach('mtc',
/**
 * MTC Front-end Component.
 *
 * @since 1.0.0
 */
{
  /**
   * Initializes the draggable functionality for the network diagram.
   *
   * @since 1.0.0
   */
  initDraggable: function initDraggable() {
    var networkDiagram = document.querySelector('.affwp-network ul');
    var networkContainer = document.querySelector('.affwp-network');

    /**
     * Used to keep the network diagram centered.
     *
     * @since 1.0.0
     */
    function centerNetworkDiagram() {
      if (!networkDiagram) {
        return; // Can't find network diagram.
      }
      var topAffiliate = networkDiagram.querySelector('li:first-child');
      if (!topAffiliate) {
        return; // Can't find the root affiliate.
      }
      var affiliateOffset = topAffiliate.offsetLeft + topAffiliate.offsetWidth / 2;
      var containerCenter = networkContainer.offsetWidth / 2;
      networkContainer.scrollLeft = affiliateOffset - containerCenter;
    }
    centerNetworkDiagram();
    var scrollableDiv = document.querySelector('.affwp-network');
    if (!scrollableDiv) {
      return; // Can't find network element.
    }
    var isDown = false;
    var startX;
    var startY;
    var scrollLeft;
    var scrollTop;
    scrollableDiv.addEventListener('mousedown', function (e) {
      isDown = true;
      scrollableDiv.style.cursor = 'grabbing';
      startX = e.pageX - scrollableDiv.offsetLeft;
      startY = e.pageY - scrollableDiv.offsetTop;
      scrollLeft = scrollableDiv.scrollLeft;
      scrollTop = scrollableDiv.scrollTop;
    });
    scrollableDiv.addEventListener('mouseleave', function () {
      isDown = false;
      scrollableDiv.style.cursor = 'grab';
    });
    scrollableDiv.addEventListener('mouseup', function () {
      isDown = false;
      scrollableDiv.style.cursor = 'grab';
    });
    scrollableDiv.addEventListener('mousemove', function (e) {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      var x = e.pageX - scrollableDiv.offsetLeft;
      var y = e.pageY - scrollableDiv.offsetTop;
      var walkX = (x - startX) * 2;
      var walkY = (y - startY) * 2;
      scrollableDiv.scrollLeft = scrollLeft - walkX;
      scrollableDiv.scrollTop = scrollTop - walkY;
    });
  }
});

},{}]},{},[1]);
